/**
 * Hook léger pour récupérer le nombre d'assignations bénévoles en attente.
 * Utilisé par la Sidebar (badge orange) et le widget Dashboard.
 */
import { useEffect, useState, useCallback } from "react";
import { benevolesApi } from "../services/api";
import useAuth from "./useAuth";

export function usePlanningPending() {
  const { isAdmin, isAuthenticated, usingMock } = useAuth();
  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(false);

  const refresh = useCallback(async () => {
    if (!isAuthenticated || !isAdmin || usingMock) return;
    setLoading(true);
    try {
      const { data } = await benevolesApi.stats();
      setCount(data.nb_en_attente_a_venir || 0);
    } catch {
      /* silencieux */
    } finally {
      setLoading(false);
    }
  }, [isAuthenticated, isAdmin, usingMock]);

  useEffect(() => { refresh(); }, [refresh]);

  return { count, loading, refresh };
}

export default usePlanningPending;
